export default __webpack_public_path__ + "static/media/008-curves.c05a20f0.png";